import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";
import ReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ReverseChargeDeterminer";
import ReverseChargeDeterminerFactory from "@/module/Form/ReverseCharge/ReverseChargeDeterminerFactory";
import { ReverseChargeSetting } from "@/module/Form/ReverseCharge/ReverseChargeSetting";

export default class DetectReverseCharge {
  private readonly foreignCustomerDeterminer: ForeignCustomerDeterminer;
  private readonly reverseChargeDeterminer: ReverseChargeDeterminer;
  private readonly reverseChargeSetting: ReverseChargeSetting;

  constructor(
    reverseChargeSetting: ReverseChargeSetting,
    foreignCustomerDeterminer: ForeignCustomerDeterminer,
    reverseChargeDeterminerFactory: ReverseChargeDeterminerFactory,
  ) {
    this.reverseChargeSetting = reverseChargeSetting;
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
    this.reverseChargeDeterminer =
      reverseChargeDeterminerFactory.create(reverseChargeSetting);
  }

  async detectReverseCharge(
    isVatPayer: boolean,
    country: string | null,
    shippingCountry: string | null,
    ic: string | null,
    dic: string | null,
    icDph: string | null,
  ): Promise<boolean> {
    if (
      !isVatPayer ||
      !this.foreignCustomerDeterminer.isForeignCustomer(country)
    ) {
      return false;
    }

    if (!this.foreignCustomerDeterminer.isCountryInEu(country)) {
      if (this.foreignCustomerDeterminer.isForeignCustomer(shippingCountry)) {
        return false;
      }

      return this.reverseChargeSetting !== ReverseChargeSetting.DISABLED;
    }

    return this.reverseChargeDeterminer.determinate(country, ic, dic, icDph);
  }
}
